/**
批量强制提交工具类
ver 1.0.0
修改记录：
  2019-07-10：
    forceSubmitUtil.
*/
let forceSubmitUtil = {}

/**
 * 是否需要批量强制提交
 *
 * @param {Object} vue vue实例
 * @param {Object} res
 * @param {String} key 需要不提示进行强制提交的key
 * @param {Funcrion} callback
 * @param {Object} modalConfig 模态框配置
 *
 */

forceSubmitUtil.forceSubmit = function ({ vue, res, key, callback, modalConfig }) {
  if (!vue || !key || !callback || !modalConfig) {
    return
  }
  if (res && res.data.errors && res.data.errors.length > 0) {
    let errorArr = res.data.errors
    let errorCount = 0
    let warningCount = 0
    for (let i = 0; i < errorArr.length; i++) {
      if (errorArr[i].level === 1) {
        errorCount++
      } else if (errorArr[i].level === 3) {
        warningCount++
      }
    }
    if (errorCount > 0) {
      vue.$pgMessage.modalUpdateResult({
        title: '提示',
        textUpdateResult: '更新完毕！',
        hideOfSuccessMessage: false,
        resultData: {
          success: '',
          fail: errorCount,
        },
      })
      return
    }

    if (warningCount >= 0) {
      if (!sessionStorage.getItem('forceSubmit')) sessionStorage.setItem('forceSubmit', '{}')
      let keysOfForceSubmit = sessionStorage.getItem('forceSubmit')
      let obj = JSON.parse(keysOfForceSubmit)
      // 没有勾选批量操作
      if (!obj.hasOwnProperty(key)) {
        // 出现提示,确认是否强制提交
        vue.$pgMessage.modalAlike({
          title: modalConfig.title,
          content: modalConfig.content,
          textOfCheckBox: modalConfig.textOfCheckBox,
          onOk: (data) => {
            if (data) {
              obj[key] = true
              sessionStorage.setItem('forceSubmit', JSON.stringify(obj))
            }
            callback()
          },
        })
      }
    }
  }
}

export default forceSubmitUtil
